export default "__VITE_ASSET__BULo9r_r__"